import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { useQuery } from '@tanstack/react-query';

import type { LmmResponse } from '../types/LmmVoorraad';

/** Fetches the LMM voorraad for each of the 3 tijdstippen (Nu, 17:00, 08:00) in parallel. */
const useGetLmmVoorraad = () => {
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery({
    queryKey: ['lmmVoorraad'],
    queryFn: async (): Promise<LmmResponse> => {
      const response = await fetchWithAuth(`/lmm/v2`);
      throwIfResponseNotOk(response, `Ophalen van LMM data is mislukt (${response.status}).`);
      return response.json();
    },
    refetchInterval: 10_000,
    meta: managedPageQueryMeta,
  });
};
export default useGetLmmVoorraad;
